import styled from 'styled-components';

import { SPACING_MAP } from './constants';

import type { LayoutProps } from './types';
import type { ComponentType } from 'react';

function calculateShorthandNumberToSpacing(value: number | string | undefined): string | undefined {
  if (typeof value === 'number') {
    // use pixels as fallback if map returns undefined
    return SPACING_MAP.get(value) || `${value}px`;
  }
  return value;
}

export function withLayoutProps<P extends object>(Component: ComponentType<P>): ComponentType<P & LayoutProps> {
  return styled(Component)<LayoutProps>`
    margin-top: ${(props) => calculateShorthandNumberToSpacing(props.marginTop || props.mt)};
    margin-right: ${(props) => calculateShorthandNumberToSpacing(props.marginRight || props.mr)};
    margin-bottom: ${(props) => calculateShorthandNumberToSpacing(props.marginBottom || props.mb)};
    margin-left: ${(props) => calculateShorthandNumberToSpacing(props.marginLeft || props.ml)};
    margin: ${(props) => calculateShorthandNumberToSpacing(props.margin)};

    padding-top: ${(props) => calculateShorthandNumberToSpacing(props.paddingTop || props.pt)};
    padding-right: ${(props) => calculateShorthandNumberToSpacing(props.paddingRight || props.pr)};
    padding-bottom: ${(props) => calculateShorthandNumberToSpacing(props.paddingBottom || props.pb)};
    padding-left: ${(props) => calculateShorthandNumberToSpacing(props.paddingLeft || props.pl)};
    padding: ${(props) => calculateShorthandNumberToSpacing(props.padding)};

    flex: ${(props) => props.flex};
    flex-direction: ${(props) => props.flexDirection};
    justify-content: ${(props) => props.justifyContent};
    align-items: ${(props) => props.alignItems};
    align-content: ${(props) => props.alignContent};
    flex-wrap: ${(props) => props.flexWrap};
    gap: ${(props) => calculateShorthandNumberToSpacing(props.gap)};

    width: ${(props) => calculateShorthandNumberToSpacing(props.width)};
    max-width: ${(props) => calculateShorthandNumberToSpacing(props.maxWidth)};
    height: ${(props) => calculateShorthandNumberToSpacing(props.height)};
    max-height: ${(props) => calculateShorthandNumberToSpacing(props.maxHeight)};
  `;
}
